import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome back, Admin");
      nav("/admin");
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 grid place-items-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white rounded-3xl border border-slate-100 shadow-lg p-8">
        <div className="text-center">
          <img src="https://customer-assets.emergentagent.com/job_healing-connect-30/artifacts/merdnxy1_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2012_57_26%20PM%20%281%29.png" alt="logo" className="w-14 h-14 rounded-2xl object-cover mx-auto" />
          <h1 className="font-serif text-3xl text-slate-900 mt-5">Admin Sign In</h1>
          <p className="text-sm text-slate-500 mt-1">Dr. Ashutosh Mishra Clinic CMS</p>
        </div>
        <form onSubmit={submit} className="mt-7 space-y-3">
          <div className="relative">
            <Mail className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              className="w-full pl-11 pr-4 py-3 rounded-xl border border-slate-200 bg-slate-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-green-500/30 focus:border-green-500 text-sm"
            />
          </div>
          <div className="relative">
            <Lock className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              className="w-full pl-11 pr-4 py-3 rounded-xl border border-slate-200 bg-slate-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-green-500/30 focus:border-green-500 text-sm"
            />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full bg-green-700 hover:bg-green-600 disabled:opacity-60 text-white rounded-full py-3 font-medium text-sm transition shadow">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <button onClick={() => nav("/")} className="mt-6 text-xs text-slate-500 hover:text-green-700 mx-auto block">← Back to website</button>
      </div>
    </div>
  );
}
